<template>
    <ErrorContent
        :type="type"
        showButtons
    />
    <Trending404 v-if="type === 404" />
</template>
<script setup lang="ts">
import { useHead } from '@unhead/vue'

import ErrorContent from '@/components/ErrorContent/ErrorContent.vue'
import { useLocalizedRouters } from '@/composables/localized-routers'
import { ROUTE_NAMES } from '@/router/constants'
import type { ErrorStatus } from '@/store/app-store'

import Trending404 from './Trending404.vue'

defineProps<{
    type: ErrorStatus
}>()

const { getCanonicalAndAlternates } = useLocalizedRouters()

useHead(() => ({
    link: getCanonicalAndAlternates({ forRoute: { name: ROUTE_NAMES.MAIN } }),
}))
</script>
